import React from 'react';
import { withRouter, NavLink, Switch, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { connect } from 'react-redux';
import * as action from '../actions';
import * as c from '../constants';

import TransactionHistoryTable from './TransactionHistoryTable';
import WalletBreakdownTable from './WalletBreakdownTable';

/* eslint-disable */
const WalletSupportTableContainer = ({
  match,
  walletTransaction,
  walletBreakDown,
  mobileNumber,
  setFormData,
  formData,
  transId,
  onClear,
}) => {

  return (
    <>
      <div className="d-flex justify-content-center">
        <NavLink
          to={`${match.url}/wallet-history`}
          exact
          activeClassName="active"
          className="wallet-link"
        >
          <span className="link-info font-weight-bold">
            Wallet Transaction History
          </span>
        </NavLink>
        <NavLink
          to={`${match.url}/wallet-breakdown`}
          exact
          activeClassName="active"
          className="wallet-link"
        >
          <span className="link-info font-weight-bold">
            Wallet Breakdown
          </span>
        </NavLink>
      </div>

      <Switch>
        {/* Transaction History */}
        <Route
          path={`${match.path}/wallet-history`}
          render={() => (
            <TransactionHistoryTable
              walletTransaction={walletTransaction}
              setFormData={setFormData}
              mobileNumber={mobileNumber}
              formData={formData}
              transId={transId}
              onClear={onClear}
            />
          )}
        />
        {/* Wallet Breakdown */}
        <Route
          path={`${match.path}/wallet-breakdown`}
          render={() => (
            <WalletBreakdownTable
              walletBreakDown={walletBreakDown}
            />
          )}
        />
      </Switch>
    </>
  );
};

WalletSupportTableContainer.propTypes = {
  history: PropTypes.instanceOf(Object).isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  walletTransaction: PropTypes.instanceOf(Array).isRequired,
  walletBreakDown: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  transId: PropTypes.string.isRequired,
  mobileNumber: PropTypes.instanceOf(Object).isRequired,
  onClear: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  searching: api.loading.indexOf(c.FIND_WALLET) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(WalletSupportTableContainer);
